export function SteeringHud({ steeringInfo: { mode, angle } }) {
	const steering_svg =
		mode === 'AUTONOMOUS'
			? 'asset/widget/steering_wheel.svg?mode=activate'
			: 'asset/widget/steering_wheel.svg?mode=default';

	return (
		<div className='absolute left-1/2'>
			<div className='absolute left-[150px] top-[30px] flex -translate-x-1/2 transform bg-[initial]'>
				<div>
					<div className='absolute pt-[15px]'>
						<div
							className='top-5 h-[57.71px] w-[76.5px]'
							style={{
								transformOrigin: '50% 50%',
								transform: `rotate(${angle}deg)`,
							}}
						>
							<object
								type='image/svg+xml'
								data={steering_svg}
								aria-label={`Steering wheel indicator showing ${angle}° ${angle > 0 ? 'right' : 'left'} turn`}
							></object>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
